import { SelectStatementColumn } from './../../../models/select-statement-column.model';
import { Title } from '@angular/platform-browser';
import { SettingsService } from './../../settings/settings.service';
import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { EsoService } from "../eso.service";
import { EsoDetailedPostingsChartDto } from "./eso-detailed-postings.models";
import { ActivatedRoute } from "@angular/router";
import { ColumnType } from "src/app/enums/columnType";
import { DetailedPostingsManualDto } from "src/app/models/detailed-postings-manual-dto";
import { LoadService } from "src/app/services/load.service";
import { Observable } from "rxjs";
import { InfoBoxService } from "src/app/services/info-box.service";
import { ListElementEnum } from 'src/app/enums/listElementEnum';
import { ListService } from 'src/app/services/list.service';
import { NavigateAssociates } from 'src/app/helpers/navigate-associates';
import { FileExportService } from 'src/app/common/file-export-service';
import { DevTooltipCustComponent } from 'src/app/widgets';
import { UtilsService } from 'src/app/services/utils.service';
import { GlobalConstants } from 'src/app/common/global-constants';
import { DxDataGridComponent } from 'devextreme-angular';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { ItemClickEvent } from 'devextreme/ui/autocomplete_types';
import { Location } from '@angular/common';

@Component({
    templateUrl: "./eso-detailed-postings.component.html",
    styleUrls: ['./eso-detailed-postings.component.scss'],
    standalone: false
})
export class EsoDetailedPostingsComponent implements OnInit {

	private readonly _componentTitle = "Eso Detailed Postings";
	private readonly _idQueryParamName = "id";

	private _location: Location = inject(Location);

	private _selectedProductId: string = null;
	public get selectedProductId(): string {
		return this._selectedProductId;
	}
	public set selectedProductId(value: string) {
		this._selectedProductId = value;

		if (this._selectedProductId) {
			const url = `eso/detailed-postings?${this._idQueryParamName}=${this._selectedProductId}`;
			this._location.replaceState(url);

			this.getData(this._selectedProductId);
		}
	}

	hasDirty = false;
	compactMode = false;
	chartData: EsoDetailedPostingsChartDto[] = [];

	public autocompleteSource: string[] = [];

	gridColumns: SelectStatementColumn[] = [];
	showInfoPopup = false;
	infoPopupMessage = '';
	infPopupTitle = '';
	gridData: {
		IsDirty: boolean;
		ProductId: string;
		[key: string]: string | number | boolean;
	}[] = [];

	editableColumns = {
		AutoCleanApproved: ColumnType.YesNo,
		ApplyEso: ColumnType.YesNo,
		ApplyForecast: ColumnType.YesNo,
		Reviewed: ColumnType.YesNo,
		Comment: ColumnType.Text,
		ManualClean: ColumnType.Number,
	};

	yesNoDataSource: { display: string; value: boolean }[];

	selectedEsoProduct = '';
	selectedPage = '';

	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

	constructor(
		private esoService: EsoService,
		private route: ActivatedRoute,
		private listService: ListService,
		private loadService: LoadService,
		private infoBoxService: InfoBoxService,
		private settingsService: SettingsService,
		private navigates: NavigateAssociates,
		private titleService: Title,
		private fileExportService: FileExportService,
		private tableParamService: TableParameterService
	) { }

	ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		this.route.queryParamMap.subscribe(
			{
				next: (queryParams) => {
					this.selectedProductId = queryParams.get(this._idQueryParamName);
				}
			}
		);

		this.esoService.getEsoObjectProductIds().subscribe(
			{
				next: (response) => {
					this.autocompleteSource = response;

					if (!this.selectedProductId && this.autocompleteSource.length > 0) {
						this.selectedProductId = this.autocompleteSource[0];
					}
				}
			}
		);

		this.listService
			.GetListElements(ListElementEnum.YesNo)
			.subscribe((res) => {
				this.yesNoDataSource = res.map((obj) => ({
					display: obj.listElement,
					value: obj.listElement === "Yes",
				}));
			});

		const urlSelectedId = this.route.snapshot.queryParamMap.get('productId');
		if (urlSelectedId) {
			this.selectedProductId = urlSelectedId;
			this.getData(this.selectedProductId);
		}

		this.WebSettingsPivot();
		this.GetSettingsData();
	}
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportEsOEsoSimulatelist").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = false;
		this.infoPopupMessage = '';
		this.infPopupTitle = '';
	}

	onProductIdChange(evt: ItemClickEvent) {
		var selectedProductId = "";
		if (evt != null && evt.itemData && evt.itemData.productId) {
			selectedProductId = evt.itemData.productId;
		}
		else if (evt != null && evt.itemData) {
			selectedProductId = evt.itemData;
		}
		if (selectedProductId != "") {
			this.selectedProductId = selectedProductId;
		}
	}

	canEdit(column: string) {
		return typeof this.editableColumns[column] === "number";
	}

	showYesNoDropdown(column: string) {
		return this.editableColumns[column] === ColumnType.YesNo;
	}

	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;
		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-eso-detailed', JSON.stringify(this.dataGrid.instance.state()));
	}

	onSaveChanges() {
		const changedItems = this.gridData
			.filter((i) => i.IsDirty)
			.map<DetailedPostingsManualDto>((item) => ({
				autoCleanApproved: item.AutoCleanApproved as boolean,
				applyEso: item.ApplyEso as boolean,
				applyForecast: item.ApplyForecast as boolean,
				reviewed: item.Reviewed as boolean,
				comment: item.Comment as string,
				manualClean: item.ManualClean as number,
				dateId: item.DateId as number,
				transactionObjectId: item.TransactionObjectId as number,
			}));

		if (changedItems.length > 0) {
			this.esoService
				.SaveDetailedPostingsManuals(changedItems)
				.subscribe((res) => {
					this.infoBoxService.show({
						message: "Data has been successfully saved!",
					});
					this.getData(this.selectedProductId);
				});
		}
	}

	onReset() {
		this.getGridData(this.selectedProductId);
	}

	onRowUpdated(event: any) {
		if (event.key.TransactionObjectId && event.key.DateId) {
			this.hasDirty = true;
			this.gridData = this.gridData.map((item) =>
				item.TransactionObjectId === event.key.TransactionObjectId &&
					item.DateId === event.key.DateId
					? { ...item, IsDirty: true }
					: item
			);
		}
	}

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift({
			location: "before",
			template: "gridActions",
		}, {
			location: "before",
			template: "heightButtonTemplate",
		}, {
			location: "before",
			template: "saveTemplate",
		}, {
			location: "before",
			template: "discardTemplate",
		});
	}

	private getData(productId: string) {
		this.getGridData(productId);

		this.esoService
			.GetDetailedPostingsChartData(productId)
			.subscribe((chartData) => {
				this.chartData = chartData;
			});
	}

	private getGridData(productId: string) {
		this.hasDirty = false;
		this.esoService
			.GetDetailedPostingsData(productId)
			.subscribe(({ columns, data }) => {
				this.gridColumns = columns;
				this.gridData = data;
			});
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotEsoDetailPosting").subscribe(result => {
			console.log(result);
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipEsoDetailPosting != null
				&& result[0].defaultSelectionTooltipEsoDetailPosting.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipEsoDetailPosting != null
				&& result[0].enableDisableTooltipEsoDetailPosting.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "", "", "");
	}
	getMarkerPath(item) {
		return UtilsService.getlegendMarkerPathDynamic(item, 'esodetailposting', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);
	}
}
